import React from 'react';

const Preloader3 = () => {
    return (
    
        <div class="lds-ellipsis3"><div ></div><div></div><div></div><div></div></div>   
    
     );
}
 
export default Preloader3;